import ProgramCreate from "src/components/ManageProgram/ProgramCreate";

export default function ManageProgramCreate() {
  return (
    <div>
      <ProgramCreate/>
    </div>
  )
}